/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type LinkResourcePathParams = NonNullable<operations['linkResource']['parameters']['path']>;

export type LinkResourceRequestBody = OperationRequestBodyContent<operations['linkResource']>;

export interface Input extends LinkResourcePathParams {
  apiVersion?: string;
  body: LinkResourceRequestBody;
}

export async function linkResource(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/views/{viewKey}/link/{resourceType}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
